var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPlateList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0347 20.7341C20.0347 15.5884 16.0378 11.4252 11.115 11.4252C6.19213 11.4252 2.1875 15.5884 2.1875 20.7341",
    stroke: "#9E9E9E",
    strokeWidth: 1.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.72865 11.5296C9.72865 11.5296 9.35828 8.95276 11.0867 8.95276C12.8151 8.95276 12.4061 11.4169 12.4061 11.4169",
    stroke: "#9E9E9E",
    strokeWidth: 1.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 21H21",
    stroke: "#9E9E9E",
    strokeWidth: 1.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.66031 6.16178C7.66031 6.16178 8.13871 5.59004 8.13871 4.64787C8.13871 3.72986 7.28223 3.28697 7.28223 2.37701C7.28223 1.52343 7.97667 1 7.97667 1",
    stroke: "#9E9E9E",
    strokeWidth: 1.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0392 6.16178C11.0392 6.16178 11.5176 5.59004 11.5176 4.64787C11.5176 3.72986 10.6611 3.28697 10.6611 2.37701C10.6611 1.52343 11.3556 1 11.3556 1",
    stroke: "#9E9E9E",
    strokeWidth: 1.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.425 6.16178C14.425 6.16178 14.9034 5.59004 14.9034 4.64787C14.9034 3.72986 14.0469 3.28697 14.0469 2.37701C14.0469 1.52343 14.7413 1 14.7413 1",
    stroke: "#9E9E9E",
    strokeWidth: 1.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlateList);
export default __webpack_public_path__ + "static/media/icon-plate-list.6bdfe46e.svg";
export { ForwardRef as ReactComponent };